import { z } from "zod";
import { idSchema, isoDateTimeSchema, paginatedResponseSchema } from "./shared";

export const inboxNotificationSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  recipientUserId: idSchema,
  issueId: idSchema.nullable(),
  type: z.string().min(1),
  title: z.string().min(1),
  body: z.string().nullable(),
  readAt: isoDateTimeSchema.nullable(),
  createdAt: isoDateTimeSchema,
});

export const inboxResponseSchema = paginatedResponseSchema(inboxNotificationSchema);
